module.exports = __webpack_public_path__ + "static/media/cc_logo.d8086b39.png";